<template>
  <div id="app" class="container">
    <div class="row">
      <div class="col-12" style="text-align: center">
        agent apply
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "agent-form",
};
</script>

<style>
#app {
  padding-top: 40px;
}
</style>